(() => {
  const openPolicyFromHash = () => {
    if (!window.location.hash) return;
    const target = document.querySelector(window.location.hash);
    if (target && target.matches('.balour-policy-center details')) {
      target.open = true;
    }
  };

  const normalizeColor = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  let linkedColorFrame = null;

  const findColorSwatchList = (productInfo) => {
    const lists = [...productInfo.querySelectorAll('ul.swatch-view, ol.swatch-view, .swatch-view')];

    return lists.find((list) => {
      const owner = list.closest('[option-name], [data-option-name], .swatch-single') || list.parentElement;
      const explicitName = owner?.getAttribute('option-name') || owner?.dataset.optionName || '';
      if (/colou?r/i.test(explicitName)) return true;

      const label = owner?.querySelector('.swatch-title, .swatch-label, legend, h2, h3, h4, label');
      return /^colou?r\b/i.test(label?.textContent?.trim() || '');
    });
  };

  const listHasColor = (list, color) => {
    const normalizedColor = normalizeColor(color);

    return [...list.querySelectorAll('.swatch-view-item:not([data-balour-linked-clone])')].some((item) => {
      const values = [
        item.getAttribute('orig-value'),
        item.getAttribute('data-value'),
        item.getAttribute('data-option-value'),
        item.getAttribute('title'),
        item.getAttribute('aria-label')
      ].filter(Boolean);

      if (values.some((value) => normalizeColor(value) === normalizedColor)) return true;
      return normalizeColor(item.textContent).split(/\n|\$/)[0].trim() === normalizedColor;
    });
  };

  const integrateLinkedColors = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const source = productInfo.querySelector('[data-balour-linked-colors]');
      if (!source) return;

      const links = [...source.querySelectorAll('[data-balour-linked-product]')];
      const list = findColorSwatchList(productInfo);
      if (!links.length || !list) return;

      const signature = links
        .map((link) => `${link.dataset.balourColorValue || ''}|${link.getAttribute('href') || ''}`)
        .join('::');
      const existingClones = [...list.querySelectorAll('[data-balour-linked-clone]')];

      if (list.dataset.balourLinkedSignature === signature && existingClones.length) {
        source.classList.add('is-swatches-integrated');
        return;
      }

      existingClones.forEach((clone) => clone.remove());

      links.forEach((sourceLink) => {
        const color = sourceLink.dataset.balourColorValue || '';
        if (listHasColor(list, color)) return;

        const item = document.createElement('li');
        const link = sourceLink.cloneNode(true);
        item.className = 'swatch-view-item balour-linked-color-item';
        item.dataset.balourLinkedClone = 'true';
        item.setAttribute('orig-value', color);
        link.addEventListener('click', (event) => event.stopPropagation());
        item.appendChild(link);
        list.appendChild(item);
      });

      list.dataset.balourLinkedSignature = signature;
      source.classList.add('is-swatches-integrated');
    });
  };

  const queueLinkedColorIntegration = () => {
    if (linkedColorFrame) return;
    linkedColorFrame = requestAnimationFrame(() => {
      linkedColorFrame = null;
      integrateLinkedColors();
    });
  };

  const startLinkedColorIntegration = () => {
    queueLinkedColorIntegration();
    const observer = new MutationObserver(queueLinkedColorIntegration);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', queueLinkedColorIntegration);
  };

  const initialize = () => {
    openPolicyFromHash();
    startLinkedColorIntegration();
  };

  window.addEventListener('hashchange', openPolicyFromHash);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
